/* tdhq-pdp.js - the product page's own scripts (U.56b, 10 Oct 2026), moved out of
   sections/dtc-product-main.liquid so they are cached and run after parsing (deferred, loaded by that section).
   In order: points row, sticky bar, main page script, description / delivery / ask dialogs. Each part returns
   when its element is not on the page. The balanced-columns script stays inline in the section (pre-paint). */
            (function () {
              var row = document.querySelector('.dtc-pdp .dtc-pdp__points[data-unit]');
              var qty = document.getElementById('PdpQty');
              if (!row) { return; }
              /* Joy counts the order subtotal (VAT included) and rounds down
                 once, so the figure is price x quantity, floored - not the
                 per-unit figure times the quantity, which rounds down per unit
                 and comes out a point short (2 x £299.99: 599, not 598). */
              function paint() {
                var unit = parseInt(row.getAttribute('data-unit'), 10) || 0;
                var price = parseInt(row.getAttribute('data-price'), 10) || 0;
                var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
                var n = unit > 0 && price > 0 ? Math.floor(price * q / 100) : 0;
                var num = row.querySelector('[data-pdp-points-n]');
                var word = row.querySelector('[data-pdp-points-word]');
                if (num) { num.textContent = n; }
                if (word) { word.textContent = n === 1 ? 'point' : 'points'; }
              }
              window.tdhqPdpPoints = paint;
              if (qty) {
                qty.addEventListener('input', paint);
                qty.addEventListener('change', paint);
                /* the + and - buttons set the value without an event */
                var box = qty.parentNode;
                if (box) { box.addEventListener('click', function () { setTimeout(paint, 0); }); }
              }
            })();
          

          (function () {
            var bar = document.querySelector('[data-pdp-sbar]');
            /* THIS PAGE'S BUY BOX ONLY. Quick view renders the same picker
               into the body on a product page, and the bar read both: it said
               "Black · M · M" after a quick view of another product (audit
               pdp-13). Captured here, before the bar moves to the body. */
            var pdp = document.querySelector('.dtc-pdp');
            var main = pdp && pdp.querySelector('[data-pdp-add]');
            if (!bar || !main || !('IntersectionObserver' in window)) { return; }
            /* Out of the buy column: an animated ancestor (a transform) would
               otherwise become the fixed bar's containing block. */
            document.body.appendChild(bar);
            var btn = bar.querySelector('[data-sbar-add]');
            var priceEl = bar.querySelector('[data-sbar-price]');
            var optsEl = bar.querySelector('[data-sbar-opts]');
            var mq = window.matchMedia('(max-width: 899px)');
            var pastBuy = false, nearFoot = false, offScreen = false, engaged = false;
            /* Shown only when there is something to add: a sold-out choice
               pinned a disabled grey button over the page for nothing.
               Also shown once the shopper has CHOSEN an option while the
               button is below the screen: on a phone the colour tiles sit
               about 450px above Add to basket, and after a pick neither the
               button nor the bar was in view (audit pdp-01). */
            /* WHENEVER THE REAL BUTTON IS OFF SCREEN, above or below (client,
               2026-09-23): on a phone the options can push Add to basket below
               the first screen, and the bar used to wait until it had scrolled
               past. A sold-out choice offers the way on instead of a dead grey
               button; a product with no price has nothing to offer here. */
            var backAskLink = pdp.querySelector('[data-pdp-backask]');
            function soldOut() { return main.disabled && !!backAskLink && !!pdp.querySelector('.dtc-pdp__buyrow.is-soldout'); }
            function sync() {
              var on = mq.matches && offScreen && !nearFoot && (!main.disabled || soldOut());
              bar.classList.toggle('is-on', on);
              /* no class on <html> any more (22 Oct 2026): toggling it while scrolling restyled the whole page */
              if (on) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
            }
            function copy() {
              var t = main.querySelector('[data-pdp-add-text]');
              if (soldOut()) {
                var bisB = pdp.querySelector('[data-tdhq-bis]');
                /* The short form: the full "Notify me when back in stock" ran
                   346px wide in a 358px row, pushed the name out and left the
                   button's end off screen (25 Sep 2026). The full label stays
                   its accessible name, which starts with the shown words. */
                var full = bisB ? bisB.textContent.trim() : 'Ask when it is back';
                btn.textContent = bisB ? 'Notify me' : full;
                btn.setAttribute('aria-label', full);
                btn.disabled = false;
                bar.classList.add('is-ask');
              } else {
                btn.textContent = (t ? t.textContent : main.textContent).trim();
                btn.removeAttribute('aria-label');
                btn.disabled = main.disabled;
                bar.classList.remove('is-ask');
              }
              var now = pdp.querySelector('[data-pdp-price] .dtc-pdp__now');
              if (now && priceEl) { priceEl.textContent = now.textContent.trim(); }
              if (optsEl) {
                /* Only real choices: a fixed single value ("A3") took the room
                   the colour needed. */
                /* Picture choices (colour, design) first: when the line is cut
                   short it is the frame or size that loses letters, not the
                   colour ("Laguna Seca Blue · Unfr..." on the 911 print). */
                var groups = [].slice.call(pdp.querySelectorAll('.tdhq-opt:not(.tdhq-opt--fixed)'));
                groups.sort(function (a, b) {
                  return (b.classList.contains('tdhq-opt--tiles') ? 1 : 0) - (a.classList.contains('tdhq-opt--tiles') ? 1 : 0);
                });
                var optsText = groups.map(function (g) {
                  var c = g.querySelector('input:checked');
                  var cur = g.querySelector('.tdhq-opt__cur');
                  return c ? (c.getAttribute('data-label') || c.value) : (cur ? cur.textContent.trim() : '');
                }).filter(Boolean).join(' · ');
                var optsSpan = optsEl.querySelector('[data-sbar-optstext]');
                if (optsSpan) { optsSpan.textContent = optsText; } else { optsEl.textContent = optsText; }
                optsEl.hidden = !optsText;
                optsEl.setAttribute('aria-label', 'Change options: ' + optsText);
              }
              sync();
            }
            new IntersectionObserver(function (es) {
              var r = es[0].boundingClientRect;
              pastBuy = !es[0].isIntersecting && r.bottom < 0;
              offScreen = !es[0].isIntersecting;
              sync();
            }).observe(main);
            /* The footer is parsed AFTER this script, so it is looked up once
               the document is complete (it was null, and the bar never hid). */
            function watchFoot() {
              var foot = document.querySelector('[data-tdhq-footer]');
              if (foot) {
                new IntersectionObserver(function (es) { nearFoot = es[0].isIntersecting; sync(); }).observe(foot);
              }
            }
            if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watchFoot); } else { watchFoot(); }
            new MutationObserver(copy).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
            var priceBox = pdp.querySelector('[data-pdp-price]');
            if (priceBox) { new MutationObserver(copy).observe(priceBox, { childList: true, subtree: true, characterData: true }); }
            document.addEventListener('change', function (e) {
              if (e.target.closest && e.target.closest('.dtc-pdp .tdhq-opts')) { engaged = true; setTimeout(copy, 60); }
            });
            if (mq.addEventListener) { mq.addEventListener('change', sync); }
            btn.addEventListener('click', function () {
              if (bar.classList.contains('is-ask')) {
                var bisBtn = pdp.querySelector('[data-tdhq-bis]');
                if (bisBtn) { bisBtn.click(); } else if (backAskLink) { backAskLink.click(); }
                return;
              }
              main.click();
            });
            /* The bar's picture is the one on the stage: after choosing
               Yellow it still showed the first variant's turquoise cloth
               beside the word Yellow. The stage picture is already loaded,
               so this costs nothing. */
            var barImg = bar.querySelector('.tdhq-sbar__img img');
            var stageImg = pdp.querySelector('.dtc-pdp__stage img');
            if (barImg && stageImg) {
              stageImg.addEventListener('load', function () {
                var src = stageImg.currentSrc || stageImg.src;
                if (!src || barImg.getAttribute('src') === src) { return; }
                barImg.removeAttribute('srcset');
                barImg.src = src;
                if (window.tdhqFit && window.tdhqFit.reset) { window.tdhqFit.reset(barImg); }
              });
            }
            if (optsEl) {
              optsEl.addEventListener('click', function () {
                var opts = pdp.querySelector('.tdhq-opts');
                if (!opts) { return; }
                var top = opts.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--tdhq-sticky-h'), 10) || 80) - 16;
                window.scrollTo({ top: top, behavior: (window.tdhqMotion ? window.tdhqMotion.behavior() : 'smooth') });
              });
            }
            copy();
          })();
        

(function () {
  /* This script renders AFTER the closing .dtc-pdp div, so closest() returns
     null and root falls back to document — and document.parentNode is null,
     which made the old `root.parentNode.querySelector(...)` THROW on line one
     of every product page. The whole enhancement layer (variant price/image/
     availability updates, thumbnail swapping) died silently; the form still
     worked no-JS, which is exactly why nothing looked broken. One PDP exists
     per page, so document scope is correct and sufficient. */
  var root = document.querySelector('.dtc-pdp') || document;
  var data = document.querySelector('[data-pdp-variants]');
  if (!data) return;
  var variants;
  try { variants = JSON.parse(data.textContent); } catch (e) { return; }

  /* The picker itself - which values exist, which are sold out, which
     variant the shopper has chosen - is driven by assets/tdhq-variants.js,
     the same engine the quick-view dialog runs, so there is one answer to
     those questions on the whole site. This page keeps only what belongs
     to a product PAGE: the gallery, the sticky bar, pickup, points and the
     address bar. */
  var idField = root.querySelector('[data-pdp-variant-id]');
  /* Script is running, so the hidden field is the one that posts. */
  if (idField) { idField.disabled = false; }
  var priceEl = root.querySelector('[data-pdp-price]');
  var addBtn = root.querySelector('[data-pdp-add]');
  var addText = root.querySelector('[data-pdp-add-text]');
  /* By CLASS, not '#PdpMainImage': the image_tag id param does not reliably
     emit an id attribute (the rendered img has none), so the id selector
     found nothing and both variant-image switching and thumbnail swapping
     silently no-opped. */
  var mainImg = root.querySelector('.dtc-pdp__stage img');
  var live = root.querySelector('[data-pdp-live]');
  /* Both labels come from data attributes, never from the button's current text.
     Reading the DOM meant soldOutLabel was whatever the FIRST variant rendered —
     "Add to basket" on any product whose first variant is in stock. */
  var inStockLabel = (addBtn && addBtn.getAttribute('data-in-label')) || 'Add to basket';
  var soldOutLabel = (addBtn && addBtn.getAttribute('data-sold-label')) || 'Out of stock';
  var poaLabel = (addBtn && addBtn.getAttribute('data-poa-label')) || 'Price on request';

  function apply(v) {
    if (!v) {
      // A combination that does not exist is a real state, not an error: say so
      // rather than leaving a live-looking button that would fail on submit.
      if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('data-buyable', 'false'); }
      if (addText) { addText.textContent = 'Unavailable'; }
      return;
    }
    if (idField) idField.value = v.id;
    var unitEl = root.querySelector('[data-pdp-unit]');
    if (unitEl) {
      var unitVal = unitEl.querySelector('[data-pdp-unit-value]');
      if (unitVal) { unitVal.textContent = v.unit_price || ''; }
      unitEl.hidden = !v.unit_price;
    }
    /* The instalments line reads its own form's id and listens for change. */
    var termsId = root.querySelector('[data-pdp-terms-id]');
    if (termsId && termsId.value !== String(v.id)) {
      termsId.value = v.id;
      termsId.dispatchEvent(new Event('change', { bubbles: true }));
    }
    /* The meta line's SKU and the SKU that travels with an Ask a question
       message both describe the SELECTED variant, so both follow the picker.
       A variant with no code hides the SKU rather than printing an empty label. */
    var skuEl = root.querySelector('[data-pdp-sku]');
    if (skuEl) {
      var skuVal = skuEl.querySelector('[data-pdp-sku-value]');
      if (skuVal) { skuVal.textContent = v.sku || ''; }
      skuEl.hidden = !v.sku;
    }
    var askSku = document.querySelector('#PdpAskForm input[name="contact[SKU]"]');
    if (askSku && v.sku) { askSku.value = v.sku; }
    if (priceEl) {
      /* The server render emits THREE children - the price, the struck-through
         was-price and the "Save GBP X" chip - plus an aria-label carrying the
         whole thing in words. The rebuild used to emit only the first two, so
         choosing a different size silently deleted the saving chip and left the
         accessible name quoting the price of a variant the shopper was no
         longer looking at. All three are rebuilt now, and the label with them. */
      var html = '<span class="dtc-pdp__now' + (v.compare_at ? ' dtc-pdp__now--sale' : '') + '">' + v.price + '</span>';
      if (v.compare_at) { html += ' <s class="dtc-pdp__was" aria-hidden="true">' + v.compare_at + '</s>'; }
      if (v.saving) { html += ' <span class="dtc-pdp__saving">Save ' + v.saving + '</span>'; }
      var priceWas = priceEl.textContent;
      priceEl.innerHTML = html;
      /* a price that moved with the option gets the site's one "this number changed" highlight */
      if (priceWas !== priceEl.textContent && window.TdhqMotion) { window.TdhqMotion.figure(priceEl); }
      if (v.price_label) { priceEl.setAttribute('aria-label', v.price_label); }
    }

    /* The quantity box follows the variant. Switching from a size with nine in
       stock to one with a single unit left has to bring the ceiling down with
       it - and if the shopper had already typed 4, that number is now wrong and
       is clamped rather than left to fail at add-to-basket. */
    var qtyEl = root.querySelector('#PdpQty');
    if (qtyEl) {
      if (v.qty_max) {
        qtyEl.setAttribute('max', v.qty_max);
        qtyEl.setAttribute('data-pdp-qty-max', '');
        if (parseInt(qtyEl.value, 10) > v.qty_max) { qtyEl.value = v.qty_max; }
      } else {
        qtyEl.removeAttribute('max');
        qtyEl.removeAttribute('data-pdp-qty-max');
      }
      /* Hand the new ceiling to the shared store and re-judge the control:
         the "+" and the note have to be right for the variant now selected
         even if the shopper never touches the quantity box. */
      if (window.TdhqQty) {
        window.TdhqQty.remember(v.id, v.qty_max || 0);
        window.TdhqQty.paint(qtyEl);
      }
    }
    /* Points come from the variant JSON, which Liquid computed — this only
       swaps the number in. Re-queried rather than captured at init because the
       price block above replaces innerHTML nearby. textContent, so a value from
       the JSON can never be interpreted as markup. */
    var pointsEl = document.querySelector('[data-pdp-points]');
    if (pointsEl && typeof v.points === 'number') {
      /* A variant priced under £1 earns nothing; hide the whole line
         rather than announce "Earn 0 points", which the brief forbids. */
      var pointsRow = pointsEl.closest('.dtc-pdp__points');
      if (pointsRow) {
        pointsRow.hidden = v.points <= 0;
        pointsRow.setAttribute('data-unit', v.points);
        if (typeof v.price_pence === 'number') { pointsRow.setAttribute('data-price', v.price_pence); }
        if (window.tdhqPdpPoints) { window.tdhqPdpPoints(); }
      }
    }
    /* Sold out: no stepper, and the two ways on (audit pdp-18). */
    var buyRow = root.querySelector('[data-pdp-buyrow]');
    if (buyRow) { buyRow.classList.toggle('is-soldout', !v.available); }
    var soldHelp = root.querySelector('[data-pdp-soldhelp]');
    if (soldHelp) { soldHelp.hidden = !!v.available; }
    /* The gallery's "Save N%" flag is the chosen variant's (REQ-PDP-24). */
    var saleBadge = root.querySelector('[data-pdp-salebadge]');
    if (saleBadge) {
      saleBadge.hidden = !v.save_pct;
      if (v.save_pct) { saleBadge.textContent = 'Save ' + v.save_pct + '%'; }
    }
    /* `buyable`, not `available`: switching to a variant with no price must
       not re-enable the button the server rendered disabled. The current
       option's state is kept on the button (data-buyable) so a finishing add
       restores THIS option's state, and nothing re-enables it mid-add (DA03). */
    if (addBtn) {
      addBtn.setAttribute('data-buyable', v.buyable ? 'true' : 'false');
      addBtn.disabled = !v.buyable || addBtn.classList.contains('is-loading');
    }
    if (addText) {
      addText.textContent = v.buyable ? inStockLabel : (v.available ? poaLabel : soldOutLabel);
    }

    /* Stock line and Click & Collect follow the variant. Both values were
       computed in Liquid into the JSON — the script only moves them. */
    var stockEl = root.querySelector('[data-pdp-stock]');
    if (stockEl && v.stock_state) {
      stockEl.className = 'dtc-pdp__stockline dtc-pdp__stockline--' + v.stock_state;
      var stockText = stockEl.querySelector('[data-pdp-stock-text]');
      if (stockText) stockText.textContent = v.stock_label;
      stockEl.hidden = !v.stock_label;
    }
    var pickupEl = root.querySelector('[data-pdp-pickup]');
    if (pickupEl) {
      pickupEl.classList.toggle('is-off', !v.pickup);
      /* U.61: the JSON's "no" is only certain for the option the page opened with; ask Shopify for the rest. */
      pickupEl.setAttribute('data-pickup-for', v.id);
      if (!v.pickup && v.available && window.tdhqPickupFor) {
        window.tdhqPickupFor(v.id).then(function (on) {
          if (on && pickupEl.getAttribute('data-pickup-for') === String(v.id)) { pickupEl.classList.remove('is-off'); }
        });
      }
    }

    /* The active ring is painted by the picker engine (it owns the controls). */
    /* Re-query each time: the price block above replaces innerHTML, and the
       live region is a sibling that must be found in the CURRENT DOM (a stale
       reference captured at init silently announces nothing). */
    var liveEl = document.querySelector('[data-pdp-live]');
    if (liveEl) {
      /* clear-then-set so the announcement fires reliably */
      liveEl.textContent = '';
      /* A single-option product posts radios named "id" and carries the whole
         label on the chosen one; anything else reads the picker's values. */
      var vradio = root.querySelector('[data-pdp-vradio]:checked');
      var label = vradio
        ? (vradio.getAttribute('data-pdp-vlabel') || '')
        : (picker ? picker.chosenLabels().join(', ') : '');
      var msg = label + '. ' + v.price + '. ' + (v.available ? (v.stock_label ? v.stock_label + '.' : '') : 'Out of stock.');
      /* setTimeout, not requestAnimationFrame: rAF is PAUSED in a hidden or
         background tab, so the announcement would never be written for anyone
         who switched tabs mid-session (proved in-browser: rAF did not fire
         with document.visibilityState === 'hidden'). A macrotask still gives
         the clear-then-set gap assistive tech needs. */
      setTimeout(function () { liveEl.textContent = msg; }, 20);
    }
    /* Route through the matching THUMB when one exists — the thumb click is
       the one sync path (stage, active ring, rail scroll, lightbox index all
       follow). Setting src directly left the ring and lightbox on the old
       image after a variant change.

       Match on PATHNAME, never the raw string: the same image_url filter
       yields `//host/cdn/...` inside the JSON but the dev proxy rewrites the
       HTML attribute to `/cdn/...` — measured unequal for the same file. The
       pathname (which includes the filename) survives both forms. */
    if (v.image && mainImg) {
      var mediaPath = function (u) {
        try { return new URL(u, window.location.origin).pathname; } catch (e) { return u; }
      };
      var vThumb = null;
      var vPath = mediaPath(v.image);
      for (var vt = 0; vt < thumbs.length; vt++) {
        if (mediaPath(thumbs[vt].getAttribute('data-pdp-thumb')) === vPath) { vThumb = thumbs[vt]; break; }
      }
      if (vThumb) {
        if (!vThumb.hasAttribute('aria-current')) { vThumb.click(); }
      } else {
        window.TdhqImg.swap(mainImg, v.image);
      }
    } else if (mainImg && thumbs.length && !thumbs[0].hasAttribute('aria-current')) {
      /* No picture for this choice (no variant image in admin, none matched):
         back to the product's own first picture rather than leaving the LAST
         colour on screen under a different colour name (Honda sunstrip: Grey
         then Violet kept the grey strip). */
      thumbs[0].click();
    }

    /* Keep ?variant= in the URL. Without it a chosen variant cannot be shared,
       bookmarked or survive a refresh — the page reopens on the default variant
       showing a different price — and Shopify's own analytics and apps read this
       parameter. replaceState, NOT pushState: a dropdown change is not a
       navigation, and pushing would fill the history stack so Back appears
       broken after a few selections. */
    if (window.history && window.history.replaceState) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* URL unsupported: the picker still works, only the address bar lags */ }
    }
  }

  /* ONE PICKER ENGINE (assets/tdhq-variants.js). It owns the controls and
     tells this page which variant is chosen; everything below reacts. The
     engine is a deferred file, so it arrives after this inline script: the
     picker starts the moment it is there. */
  /* The thumbs are gathered BEFORE the picker starts: apply() reads them,
     and when the engine was already loaded (a theme editor section reload)
     apply() ran while `thumbs` was still undefined and threw, and the
     gallery, lightbox and ajax add below never bound (audit pdp-23). */
  var thumbs = [].slice.call(root.querySelectorAll('[data-pdp-thumb]'));
  var picker = null;
  function startPicker() {
    if (picker || !window.TdhqVariants) { return; }
    picker = window.TdhqVariants.init(root, { onChange: function (v) { apply(v); } });
    if (picker) { apply(picker.match()); }
  }
  startPicker();
  if (!picker) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', startPicker); }
    else { window.setTimeout(startPicker, 0); }
  }

  /* Quantity stepper. The number input is the real, posted control; these
     buttons only nudge it, so no-JS loses nothing but the convenience. */
  [].slice.call(root.querySelectorAll('[data-pdp-step]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = root.querySelector('#PdpQty');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var next = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-pdp-step'), 10);
      /* THE CEILING, not just the floor. Math.max(min, next) let "+" climb to
         64 of a variant with one in stock; the refusal then came from Shopify
         at add-to-basket, or from the basket quietly reducing it afterwards.
         TdhqQty subtracts what the basket already holds, so a shopper with 2
         of a 3-stock variant can add 1 more and no more. */
      if (window.TdhqQty) {
        input.value = window.TdhqQty.allowed(
          window.TdhqQty.variantOf(input), next, 'add', min).value;
        window.TdhqQty.paint(input);
      } else {
        input.value = Math.max(min, next);
      }
    });
  });

  // Thumbnails swap the stage image. srcset must go too, or the browser keeps
  // serving a candidate from the old set and the picture never changes.
  var lbCurrent = 0; // images-only index of what the stage is showing
  // On a ?variant= deep link the server marks the variant's thumb as current,
  // so the lightbox must start there too — not blindly at image 0.
  var lbInitBtn = root.querySelector('[data-pdp-thumb][aria-current="true"]');
  if (lbInitBtn && lbInitBtn.hasAttribute('data-lb-index')) {
    lbCurrent = parseInt(lbInitBtn.getAttribute('data-lb-index'), 10) || 0;
  }
  /* Warm the SECOND picture once the page is quiet: it is the one nearly every
     shopper opens next, and having it decoded makes that tap instant. One
     image, at idle, so it never competes with the picture on screen. */
  (window.requestIdleCallback || function (f) { return window.setTimeout(f, 1500); })(function () {
    var cur = 0;
    for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].hasAttribute('aria-current')) { cur = i; break; } }
    var nextBtn = thumbs[cur + 1] || thumbs[cur - 1];
    if (!nextBtn || !mainImg) { return; }
    var warm = new Image();
    var ss = nextBtn.getAttribute('data-pdp-thumb-srcset');
    if (ss) { warm.srcset = ss; warm.sizes = mainImg.getAttribute('sizes') || ''; }
    warm.src = nextBtn.getAttribute('data-pdp-thumb');
  }, { timeout: 4000 });
  /* Which tap the frame is currently answering: a later tap always wins. */
  var swapToken = 0, stageBusy = 0;
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      /* KEEP IT RESPONSIVE. This used to set the fixed 1400px URL and REMOVE the
         srcset, so every photo after the first cost a phone 2.2x the bytes it
         needed (42,917 B where 19,233 B would do). The server-rendered `sizes`
         stays on the element, so the browser picks the same way it did for the
         first image. */
      /* A video thumb puts its player over the stage; any other thumb takes
         a player away (which stops it). Reduced motion: no autoplay, the
         shopper presses play. */
      var stageBox = root.querySelector('.dtc-pdp__stage');
      var oldVid = stageBox && stageBox.querySelector('.dtc-pdp__video');
      if (oldVid) { oldVid.remove(); }
      var vtpl = btn.querySelector('template[data-pdp-video]');
      if (vtpl && stageBox && vtpl.content.firstElementChild) {
        var vnode = vtpl.content.firstElementChild.cloneNode(true);
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (still && vnode.tagName === 'VIDEO') { vnode.removeAttribute('autoplay'); }
        stageBox.appendChild(vnode);
        if (!still && vnode.play) { var pp = vnode.play(); if (pp && pp.catch) { pp.catch(function () {}); } }
      }
      var thumbSet = btn.getAttribute('data-pdp-thumb-srcset');
      var nextSrc = btn.getAttribute('data-pdp-thumb');
      /* DECODE FIRST, THEN SWAP. Setting src on the picture that is on screen
         emptied the frame while the new file downloaded: measured 0.95 to
         1.88s of blank white per tap on a phone. The new picture is fetched
         and decoded beside the page and only then put in the frame, so what
         the shopper is looking at never disappears. */
      var token = ++swapToken;
      /* A slow download says so: after 180ms (a fast swap never shows it) the
         stage dims until the new picture is in (audit img-14: 1.7s of the old
         picture after a tap on a slow phone, with nothing to say it had
         registered). */
      window.clearTimeout(stageBusy);
      if (stageBox) { stageBox.classList.remove('is-swapping'); }
      stageBusy = window.setTimeout(function () { if (token === swapToken && stageBox) { stageBox.classList.add('is-swapping'); } }, 180);
      var next = new Image();
      if (thumbSet) {
        next.srcset = thumbSet;
        next.sizes = mainImg.getAttribute('sizes') || '';
      }
      next.src = nextSrc;
      var show = function () {
        if (token !== swapToken || !mainImg) { return; }
        window.clearTimeout(stageBusy);
        if (stageBox) { stageBox.classList.remove('is-swapping'); }
        var swap = function () {
          if (thumbSet) { mainImg.srcset = thumbSet; } else { mainImg.removeAttribute('srcset'); }
          mainImg.src = nextSrc;
          /* the fit belongs to the IMAGE, not the frame - see data-fill above */
          mainImg.classList.toggle('is-fill', btn.getAttribute('data-fill') === '1');
          /* The judged fit belongs to THIS picture: drop the last verdict and let
             the fit script place the new one. One it has judged before is applied
             at once, with no request. */
          if (window.tdhqFit && window.tdhqFit.reset) { window.tdhqFit.reset(mainImg); }
        };
        /* The old picture fades off the new one (assets/tdhq-variants.js):
           the swap was instant, "super bad, no animation" (client; audit
           MOT-09). The same picture again is not faded. */
        var same = (mainImg.currentSrc || mainImg.src) === next.currentSrc;
        if (!same && window.TdhqVariants && window.TdhqVariants.fadeSwap) { window.TdhqVariants.fadeSwap(mainImg, swap); }
        else { swap(); }
      };
      /* a picture that fails keeps the one on show and lifts the waiting dim (tdhqImgReady, dtc-core.js) */
      (window.tdhqImgReady || function (i, ok) { if (i.complete) { ok(); } else { i.onload = ok; i.onerror = ok; } })(next, show, function () {
        if (token !== swapToken) { return; }
        window.clearTimeout(stageBusy);
        if (stageBox) { stageBox.classList.remove('is-swapping'); }
      });
      thumbs.forEach(function (b) { b.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
      if (btn.hasAttribute('data-lb-index')) {
        lbCurrent = parseInt(btn.getAttribute('data-lb-index'), 10) || 0;
      }
      // The rail scrolls instead of wrapping — keep the active thumb visible.
      // Scrolls only the <ul>, so the page position is never touched.
      // 'instant', NOT 'smooth': with the theme's CSS scroll-behavior:smooth
      // in force, a programmatic smooth scroll here silently lands at 0
      // (measured) — the same environment gotcha as the probe scrollTo rule.
      var rail = btn.closest('[data-pdp-thumbs]');
      if (rail) {
        var cell = btn.parentElement;
        /* The rail is a horizontal strip under the stage on a phone and a
           VERTICAL column beside it from 900px up, so the axis is read off the
           element rather than assumed. Centring on the wrong axis is a silent
           no-op that leaves the active thumb parked off-screen - which is what
           thumb 13 of 13 did on desktop. */
        if (rail.scrollWidth > rail.clientWidth) {
          rail.scrollTo({
            left: Math.max(0, cell.offsetLeft - (rail.clientWidth - cell.offsetWidth) / 2),
            behavior: 'instant'
          });
        }
        if (rail.scrollHeight > rail.clientHeight) {
          /* Measured from the boxes, not offsetTop: the rail is not a
             positioned element, so offsetTop is reported against whichever
             ancestor happens to be positioned (the sticky gallery today) and
             would silently move if that ever changed. */
          var cr = cell.getBoundingClientRect();
          var rr = rail.getBoundingClientRect();
          rail.scrollTo({
            top: Math.max(0, rail.scrollTop + (cr.top - rr.top) - (rail.clientHeight - cr.height) / 2),
            behavior: 'instant'
          });
        }
      }
    });
  });

  /* THE RAIL'S OVERFLOW CUE. Sets the two classes the fade in dtc-core.css
     paints from, on whichever side actually still has thumbs. ResizeObserver
     fires once when it starts observing, and that is the first measure on
     purpose: the rail is sized by min-height against the stage, whose square
     is not final until the stage image has loaded, so measuring here and now
     would read a height that is about to change. Every scroll re-measures, and
     the thumb click above scrolls the rail, so stepping with the stage arrows
     keeps the fade honest too. On a phone the rail is the horizontal strip and
     its scrollHeight matches its box, so no class is ever set below 900px -
     and the CSS is media-gated there as well. */
  function railFade(rail) {
    var max = rail.scrollHeight - rail.clientHeight;
    rail.classList.toggle('is-fade-top', max > 4 && rail.scrollTop > 2);
    rail.classList.toggle('is-fade-bottom', max > 4 && rail.scrollTop < max - 2);
    /* U.26: from 900px the rail is a row under the picture, so the cue reads the
       other axis too (CSS gates both to 900px and up). */
    var maxX = rail.scrollWidth - rail.clientWidth;
    rail.classList.toggle('is-fade-left', maxX > 4 && rail.scrollLeft > 2);
    rail.classList.toggle('is-fade-right', maxX > 4 && rail.scrollLeft < maxX - 2);
  }
  [].slice.call(root.querySelectorAll('[data-pdp-thumbs]')).forEach(function (rail) {
    rail.addEventListener('scroll', function () { railFade(rail); }, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { railFade(rail); }).observe(rail);
    } else {
      railFade(rail);
      window.addEventListener('resize', function () { railFade(rail); });
    }
  });

  // Stage arrows re-use the thumbnail click path — one sync mechanism for
  // stage image, active ring and lightbox index, nothing to drift.
  function stageStep(dir) {
    if (!thumbs.length) return;
    var cur = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].hasAttribute('aria-current')) { cur = i; break; }
    }
    thumbs[(cur + dir + thumbs.length) % thumbs.length].click();
  }
  var stagePrev = root.querySelector('[data-pdp-stageprev]');
  var stageNext = root.querySelector('[data-pdp-stagenext]');
  if (stagePrev) { stagePrev.addEventListener('click', function () { stageStep(-1); }); }
  if (stageNext) { stageNext.addEventListener('click', function () { stageStep(1); }); }

  /* SWIPE, on touch. A 280px drag across the phone stage changed nothing:
     pictures moved only by the 44px arrows or the thumb strip (audit pdp-04).
     A sideways swipe of 40px or more, clearly more across than down, steps
     through the same thumb path as the arrows (stage, ring and lightbox
     index stay in step). The stage is touch-action: pan-y below 900px, so
     an up-and-down swipe still scrolls the page. The tap a finger makes as
     it lifts must not then open the full-screen gallery. */
  function onSwipe(el, step) {
    var sx = null, sy = 0, swipedAt = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') { sx = null; return; }
      sx = e.clientX; sy = e.clientY;
    }, { passive: true });
    el.addEventListener('pointercancel', function () { sx = null; }, { passive: true });
    el.addEventListener('pointerup', function (e) {
      if (sx === null) { return; }
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        swipedAt = Date.now();
        step(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
    el.addEventListener('click', function (e) {
      if (Date.now() - swipedAt < 400) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }
  var stageEl = root.querySelector('.dtc-pdp__stage');
  if (stageEl && thumbs.length > 1) { onSwipe(stageEl, stageStep); }

  /* ---- Gallery lightbox --------------------------------------------------
     Native <dialog> supplies modal focus, Escape and the top layer; this only
     moves the index. A second click on the image toggles 1:1 zoom — the stage
     scrolls to pan, so no drag machinery is needed. Sources are 2048px and
     load on demand; neighbours preload so arrows feel instant. */
  var lbDialog = root.querySelector('[data-pdp-lightbox]');
  var lbDataEl = root.querySelector('[data-lb-data]');
  if (lbDialog && lbDataEl && typeof lbDialog.showModal === 'function') {
    var lbItems = [];
    try { lbItems = JSON.parse(lbDataEl.textContent) || []; } catch (e) { lbItems = []; }
    var lbImg = lbDialog.querySelector('[data-lb-img]');
    var lbStage = lbDialog.querySelector('[data-lb-stage]');
    var lbCount = lbDialog.querySelector('[data-lb-count]');

    var lbToken = 0;
    /* The picture is drawn up to min(92vw, 1600px) wide (the full width on a
       phone) and 86% of the window tall, so its width on screen follows its
       shape - and never past its own file width, which it is not stretched
       beyond. The browser is told that width and takes the candidate it needs
       (audit img-6: one 2048px file was 5x what a phone draws). */
    function lbSizes(item) {
      var vw = window.innerWidth, vh = window.innerHeight;
      var slot = Math.min(vw < 600 ? vw : Math.min(vw * 0.92, 1600), vh * 0.86 * (parseFloat(item.ar) || 1));
      return Math.max(1, Math.round(Math.min(slot, item.w || slot))) + 'px';
    }
    function lbFeed(im, item) {
      im.style.width = '';
      if (item.ss) { im.sizes = lbSizes(item); im.srcset = item.ss; }
      else { im.removeAttribute('srcset'); im.removeAttribute('sizes'); }
      im.src = item.src;
    }
    function lbShow(i) {
      if (!lbItems.length) return;
      lbCurrent = (i + lbItems.length) % lbItems.length;
      var item = lbItems[lbCurrent];
      lbCount.textContent = (lbCurrent + 1) + ' / ' + lbItems.length;
      lbDialog.classList.remove('is-zoomed');
      /* Decoded first, then faded in over the last picture, as on the
         stage; the first picture of an opening lightbox is simply set. */
      var mine = ++lbToken;
      var put = function () {
        if (mine !== lbToken) { return; }
        var swap = function () { lbFeed(lbImg, item); lbImg.alt = item.alt || ''; };
        if (lbDialog.open && lbImg.naturalWidth > 1 && window.TdhqVariants && window.TdhqVariants.fadeSwap) {
          window.TdhqVariants.fadeSwap(lbImg, swap);
        } else { swap(); }
      };
      var pre = new Image();
      lbFeed(pre, item);
      (window.tdhqImgReady || function (i, ok) { if (i.complete) { ok(); } else { i.onload = ok; i.onerror = ok; } })(pre, put);
      // Preload the neighbours only — never the whole set.
      [lbCurrent + 1, lbCurrent - 1].forEach(function (n) {
        var it = lbItems[(n + lbItems.length) % lbItems.length];
        if (it) { lbFeed(new Image(), it); }
      });
    }

    var zoomBtn = root.querySelector('[data-pdp-zoom]');
    if (zoomBtn && lbItems.length) {
      zoomBtn.addEventListener('click', function () {
        lbShow(lbCurrent);
        lbDialog.showModal();
      });
    }

    lbDialog.querySelector('[data-lb-close]').addEventListener('click', function () { lbDialog.close(); });
    lbDialog.querySelector('[data-lb-prev]').addEventListener('click', function () { lbShow(lbCurrent - 1); });
    lbDialog.querySelector('[data-lb-next]').addEventListener('click', function () { lbShow(lbCurrent + 1); });
    lbDialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(lbCurrent - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbCurrent + 1); }
    });
    // Clicking the dark ground (not the image or a control) closes.
    lbStage.addEventListener('click', function (e) {
      if (e.target === lbStage) { lbDialog.close(); }
    });
    /* Zoom draws the picture at its file size, so the full file goes in
       first - decoded, so the zoom never lands on a blank frame. */
    lbImg.addEventListener('click', function () {
      if (lbDialog.classList.contains('is-zoomed')) { lbDialog.classList.remove('is-zoomed'); lbImg.style.width = ''; return; }
      var item = lbItems[lbCurrent];
      if (!item || !lbImg.getAttribute('srcset')) {
        if (item && item.w) { lbImg.style.width = item.w + 'px'; }
        lbDialog.classList.add('is-zoomed');
        return;
      }
      var mine = lbToken;
      var full = new Image();
      full.src = item.src;
      var go = function () {
        if (mine !== lbToken) { return; }
        lbImg.removeAttribute('srcset');
        lbImg.removeAttribute('sizes');
        lbImg.src = item.src;
        if (item.w) { lbImg.style.width = item.w + 'px'; }
        lbDialog.classList.add('is-zoomed');
      };
      (window.tdhqImgReady || function (i, ok) { if (i.complete) { ok(); } else { i.onload = ok; i.onerror = ok; } })(full, go);
    });
    /* Sideways swipe steps the lightbox on touch (REQ-VID-02); a zoomed
       picture pans instead. */
    onSwipe(lbStage, function (dir) {
      if (!lbDialog.classList.contains('is-zoomed')) { lbShow(lbCurrent + dir); }
    });
  }

  /* ---- Add to basket WITHOUT leaving the page ----------------------------
     The plain form POSTs to /cart/add and redirects to the cart, which throws
     the shopper out of the product they were reading — the single biggest
     conversion cost in the old flow. Intercept, post to /cart/add.js, update
     the header badge and confirm in place.

     The form remains a real POST form, so with JS unavailable the original
     behaviour is untouched. Any failure falls back to submitting for real,
     which surfaces Shopify's own error page rather than swallowing it. */
  /* By id first: the instalments form above the price is also a /cart/add
     form, and first in the document. */
  var form = document.getElementById('PdpForm') || root.querySelector('form[action$="/cart/add"], .dtc-pdp__form');
  if (form && 'fetch' in window) {
    var toast;
    function showToast(msg, isError) {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'dtc-pdp__toast';
        /* status, not alert: an addition is confirmation, not a warning */
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.classList.toggle('is-error', !!isError);
      toast.innerHTML = '';
      /* the house notice: icon tile, title, text (window.TdhqNote, tdhq-cart-drawer.js; 23 Oct 2026) */
      if (window.TdhqNote) {
        window.TdhqNote.fill(toast, msg, isError ? null : 'ok');
        toast.classList.add('tdhq-note--side');
      } else {
        var text = document.createElement('span');
        text.textContent = msg;
        toast.appendChild(text);
      }
      if (!isError) {
        var link = document.createElement('a');
        link.href = '/cart';
        link.className = 'dtc-pdp__toastlink';
        link.textContent = 'View basket';
        toast.appendChild(link);
      }
      toast.classList.add('is-open');
      clearTimeout(showToast.t);
      showToast.t = setTimeout(function () { toast.classList.remove('is-open'); }, 6000);
    }

    function refreshBadge() {
      window.TdhqCart.get().then(function (c) {
        document.querySelectorAll('[data-tdhq-cart-count]').forEach(function (el) {
          var sr = el.querySelector('.tdhq-visually-hidden, .visually-hidden');
          el.textContent = c.item_count;
          if (sr) {
            el.appendChild(sr);
            sr.textContent = c.item_count === 1 ? 'item in basket' : 'items in basket';
          }
          el.classList.toggle('tdhq-hidden', c.item_count === 0);
        });
      }).catch(function () {});
    }

    form.addEventListener('submit', function (e) {
      /* the checkout button inside a cart form must never be intercepted */
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      /* one add at a time, and never for an option that cannot be bought */
      if (addBtn && (addBtn.classList.contains('is-loading') || addBtn.getAttribute('data-buyable') === 'false')) return;
      if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }

      /* A battery kit built from its parts (data-tdhq-kit-items, snippets/tdhq-kit-items.liquid) adds the parts as
         separate basket lines, each times the quantity, never the kit itself (owner + Simon, 20 Oct 2026). */
      var kitList = null;
      try { kitList = JSON.parse((form.getAttribute('data-tdhq-kit-items') || '').trim() || 'null'); } catch (err) { kitList = null; }
      if (!Array.isArray(kitList) || !kitList.length) { kitList = null; }
      var data = new FormData(form);
      data.set('sections', 'tdhq-cart-state');
      data.set('sections_url', window.location.pathname);
      var addReq = { method: 'POST', body: data };
      if (kitList) {
        var kitQty = parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
        addReq = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: kitList.map(function (p) { return { id: p[0], quantity: p[1] * kitQty }; }), sections: 'tdhq-cart-state', sections_url: window.location.pathname }) };
      }
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', addReq)
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || err.message || 'Could not add to basket'); });
          return r.json();
        })
        .then(function (item) {
          if (!window.tdhqCartDrawer) { refreshBadge(); }
          /* The basket drawer replaces the success toast. A toast confirmed the
             add but could not show what was in the basket, adjust it, or lead to
             checkout, so every add still cost a page load to /cart to verify.
             The drawer answers all three in place.

             Dispatch rather than call: this section owns ADDING, the drawer owns
             SHOWING. If no drawer is present (a stripped template, or the asset
             failing to load) nothing listens and the toast below is the fallback. */
          var shown = false;
          if (window.tdhqCartDrawer) {
            document.dispatchEvent(new CustomEvent('tdhq:cart:added', { detail: { source: 'pdp', productId: Number((root.querySelector('input[name="product-id"]') || {}).value) || null, item: item } }));
            shown = true;
          }
          if (!shown) { var addedName = item.product_title || item.title || (item.items && item.items[0] && item.items[0].product_title); showToast('Added: ' + (window.tdhqName ? window.tdhqName(addedName) : addedName)); }
          if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.disabled = addBtn.getAttribute('data-buyable') === 'false'; }
        })
        .catch(function (err) {
          if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.disabled = addBtn.getAttribute('data-buyable') === 'false'; }
          showToast(err.message || 'Could not add to basket', true);
          /* a refused kit add may still have put some of its parts in the basket */
          if (kitList && window.TdhqQty && window.TdhqQty.reconcile) { window.TdhqQty.reconcile(); }
        });
    });
  }
})();

(function () {
  var dlg = document.querySelector('[data-pdp-desc]');
  var opener = document.querySelector('[data-pdp-desc-open]');
  if (!dlg || !opener || typeof dlg.showModal !== 'function') return;
  opener.setAttribute('role', 'button');
  /* The page behind a modal must not scroll. Said with a class rather than
     html:has(dialog[open]), which made every change anywhere on the page
     re-check the whole document. */
  function lockPage(on) { document.documentElement.classList.toggle('dtc-desc-open', on); }
  function openDesc(e) {
    if (e) { e.preventDefault(); }
    if (!dlg.open) { dlg.showModal(); lockPage(true); }
  }
  dlg.addEventListener('close', function () { lockPage(false); });
  opener.addEventListener('click', openDesc);
  /* role="button" promises Space as well as Enter. */
  opener.addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Spacebar') { openDesc(e); }
  });
  var closeBtn = dlg.querySelector('[data-pdp-desc-close]');
  if (closeBtn) { closeBtn.addEventListener('click', function () { dlg.close(); }); }
  /* A click on the backdrop lands on the dialog element itself; a click on its
     content never does. */
  dlg.addEventListener('click', function (e) { if (e.target === dlg) { dlg.close(); } });
})();

(function () {
  var dlg = document.querySelector('[data-pdp-deliv]');
  var opener = document.querySelector('[data-pdp-deliv-open]');
  if (!dlg || !opener || typeof dlg.showModal !== 'function') return;
  opener.setAttribute('role', 'button');
  function lockPage(on) { document.documentElement.classList.toggle('dtc-desc-open', on); }
  /* The rate tables and delivery list are the same on every product page, so they come from
     /?section_id=tdhq-pdp-delivery on the first open (U.66 F11): the popup opens at once with its
     frame and the product's own delivery line, and fills when the body arrives. */
  var filled = false;
  function fill() {
    if (filled || !('fetch' in window)) { return; }
    filled = true;
    var coll = dlg.getAttribute('data-deliv-collective') === 'true' ? 'true' : 'false';
    fetch('/?section_id=tdhq-pdp-delivery', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var frag = holder.querySelector('[data-deliv-frag="' + coll + '"]');
        if (!frag) { throw new Error('no body'); }
        ['ways', 'rates'].forEach(function (k) {
          var slot = dlg.querySelector('[data-deliv-slot="' + k + '"]');
          var part = frag.querySelector('[data-deliv-part="' + k + '"]');
          if (slot && part) { slot.replaceWith.apply(slot, Array.prototype.slice.call(part.childNodes)); }
        });
      })
      .catch(function () {
        /* the next open tries again; until then the empty slots say why */
        filled = false;
        var slot = dlg.querySelector('[data-deliv-slot="rates"]');
        if (slot && !slot.querySelector('[data-deliv-fail]')) {
          var note = document.createElement('p');
          note.setAttribute('data-deliv-fail', '');
          note.setAttribute('role', 'status');
          note.textContent = 'Delivery details could not load. Close this and open it again, or use Full Delivery Information below.';
          slot.appendChild(note);
        }
      });
  }
  function openIt(e) {
    if (e) {
      if (e.type === 'click' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) { return; }
      e.preventDefault();
    }
    fill();
    if (!dlg.open) { dlg.showModal(); lockPage(true); }
  }
  dlg.addEventListener('close', function () { lockPage(false); });
  opener.addEventListener('click', openIt);
  opener.addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Spacebar') { openIt(e); }
  });
  var closeBtn = dlg.querySelector('[data-pdp-deliv-close]');
  if (closeBtn) { closeBtn.addEventListener('click', function () { dlg.close(); }); }
  dlg.addEventListener('click', function (e) { if (e.target === dlg) { dlg.close(); } });
})();

(function () {
  var dlg = document.querySelector('[data-pdp-ask]');
  var opener = document.querySelector('[data-pdp-ask-open]');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  function open(e) {
    if (e) { e.preventDefault(); }
    if (!dlg.open) { dlg.showModal(); }
  }
  if (opener) {
    opener.addEventListener('click', open);
    opener.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') { open(e); }
    });
  }
  var closeBtn = dlg.querySelector('[data-pdp-ask-close]');
  if (closeBtn) { closeBtn.addEventListener('click', function () { dlg.close(); }); }
  /* a click on the backdrop lands on the dialog element itself */
  dlg.addEventListener('click', function (e) { if (e.target === dlg) { dlg.close(); } });

  /* A message started for the shopper, only into an empty box: what they
     have typed is never replaced. */
  function begin(text) {
    var box = dlg.querySelector('textarea');
    if (box && text && !box.value.trim()) { box.value = text; }
    open();
    if (box) {
      box.focus({ preventScroll: true });
      try { box.setSelectionRange(box.value.length, box.value.length); } catch (err) {}
    }
  }

  /* SOLD OUT: "Ask when it is back" starts that message, naming the
     product and the options chosen (audit pdp-18). */
  var backAsk = document.querySelector('[data-pdp-backask]');
  if (backAsk) {
    backAsk.addEventListener('click', function (e) {
      e.preventDefault();
      var opts = [].slice.call(document.querySelectorAll('.dtc-pdp .tdhq-opt:not(.tdhq-opt--fixed) input:checked'))
        .map(function (i) { return i.getAttribute('data-label') || i.value; }).filter(Boolean).join(', ');
      var name = backAsk.getAttribute('data-title') || '';
      begin('Please tell me when ' + name + (opts ? ' (' + opts + ')' : '') + ' is back in stock.');
    });
  }
  /* SOLD OUT: Notify Me When Back in Stock (U.37, 8 Oct) opens the theme's own
     dialog (pdp-bis), which holds a real Shopify signup form. On submit the
     tags are set to the option on screen (bis-<variant id>) and the form is
     sent into the hidden frame: Shopify's own script adds its CAPTCHA token
     first, and the frame's answer decides what the dialog says. If Shopify
     wants a visible CAPTCHA, the same form is sent in the page itself so the
     shopper can answer it, and the page comes back with the thank-you open. */
  var bisBtn = document.querySelector('[data-tdhq-bis]');
  var bisDlg = document.querySelector('[data-pdp-bis]');
  if (bisBtn && bisDlg && typeof bisDlg.showModal === 'function') {
    var bisForm = bisDlg.querySelector('[data-pdp-bis-form]');
    var bisEmail = bisDlg.querySelector('#PdpBisEmail');
    var bisTags = bisDlg.querySelector('[data-pdp-bis-tags]');
    var bisSubmit = bisDlg.querySelector('[data-pdp-bis-submit]');
    var bisDone = bisDlg.querySelector('[data-pdp-bis-done]');
    var bisErr = bisDlg.querySelector('[data-pdp-bis-error]');
    var bisFields = bisDlg.querySelector('[data-pdp-bis-fields]');
    var bisConsent = bisDlg.querySelector('[data-pdp-bis-consent]');
    var bisVar = bisDlg.querySelector('[data-pdp-bis-variant]');
    var bisFrame = bisDlg.querySelector('[data-pdp-bis-frame]');
    var bisBusy = false;
    var bisTimer = null;
    bisForm.noValidate = true;
    bisForm.target = 'tdhq-bis-frame';
    var bisState = function (state) {
      var done = state === 'done';
      bisFields.hidden = done;
      bisConsent.hidden = done;
      bisSubmit.hidden = done;
      bisDone.hidden = !done;
      bisErr.hidden = state !== 'error';
      if (window.TdhqMotion) {
        if (done) { window.TdhqMotion.show(bisDone); }
        if (state === 'error') { window.TdhqMotion.show(bisErr); }
      }
      bisSubmit.disabled = state === 'busy';
      bisSubmit.classList.toggle('is-loading', state === 'busy');
    };
    var bisAside = false;
    var bisWatch = null;
    /* While a request is sent the dialog is non-modal (is-sending): a modal
       dialog makes the rest of the page inert, and Shopify's CAPTCHA works
       through its own frame out there, so it never answered (U.37h). */
    var bisModal = function () {
      if (bisDlg.open && !bisDlg.matches(':modal')) { bisDlg.close(); }
      if (!bisDlg.open) { bisDlg.showModal(); }
      setTimeout(function () { bisDlg.classList.remove('is-sending'); }, 0);
    };
    var bisEnd = function (state) {
      bisBusy = false;
      if (bisTimer) { clearTimeout(bisTimer); bisTimer = null; }
      if (bisWatch) { clearInterval(bisWatch); bisWatch = null; }
      bisState(state);
      if (bisAside || bisDlg.classList.contains('is-sending')) { bisModal(); }
      bisAside = false;
    };
    /* A visible CAPTCHA challenge sits under the modal dialog, where it can
       be neither seen nor answered: while the request waits, the dialog
       steps aside for it and comes back when Shopify answers. */
    var bisChallenge = function () {
      var f = document.querySelector('iframe[src*="hcaptcha"][src*="challenge"]');
      if (!f) { return false; }
      var box = f.parentElement && f.parentElement.parentElement;
      return getComputedStyle(f).visibility === 'visible' && (!box || getComputedStyle(box).visibility !== 'hidden') && f.offsetWidth > 0;
    };
    var bisGiveUp = function (ms) {
      if (bisTimer) { clearTimeout(bisTimer); }
      bisTimer = setTimeout(function () { if (bisBusy) { bisEnd('error'); } }, ms);
    };
    bisBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var opts = [].slice.call(document.querySelectorAll('.dtc-pdp .tdhq-opt:not(.tdhq-opt--fixed) input:checked'))
        .map(function (i) { return i.getAttribute('data-label') || i.value; }).filter(Boolean).join(', ');
      bisVar.textContent = opts;
      bisVar.hidden = !opts;
      if (!bisBusy) { bisState('ready'); }
      bisDlg.showModal();
    });
    bisDlg.querySelector('[data-pdp-bis-close]').addEventListener('click', function () { bisDlg.close(); });
    bisDlg.addEventListener('click', function (e) { if (e.target === bisDlg) { bisDlg.close(); } });
    /* Capture phase, so it runs before Shopify's CAPTCHA listener, which
       always goes on to post the form: a refused address must stop here. */
    bisForm.addEventListener('submit', function (e) {
      if (bisBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (!bisEmail.value.trim() || !bisEmail.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        bisEmail.reportValidity();
        return;
      }
      var idField = document.querySelector('[data-pdp-variant-id]');
      var id = idField && idField.value ? idField.value : '';
      bisTags.value = 'back-in-stock' + (id ? ',bis-' + id + '-' + bisTags.getAttribute('data-handle') : '');
      try { sessionStorage.setItem('tdhq-bis-sent', '1'); } catch (err) {}
      bisBusy = true;
      bisState('busy');
      bisDlg.classList.add('is-sending');
      if (bisDlg.open && bisDlg.matches(':modal')) { bisDlg.close(); bisDlg.show(); }
      bisGiveUp(30000);
      if (bisWatch) { clearInterval(bisWatch); }
      bisWatch = setInterval(function () {
        if (!bisBusy) { return; }
        var shown = bisChallenge();
        if (shown && !bisAside) {
          bisAside = true;
          if (bisTimer) { clearTimeout(bisTimer); bisTimer = null; }
          if (bisDlg.open) { bisDlg.close(); }
        } else if (!shown && bisAside && !bisTimer) {
          bisGiveUp(8000);
        }
      }, 300);
    }, true);
    bisFrame.addEventListener('load', function () {
      if (!bisBusy) { return; }
      var href = '';
      var foreign = false;
      try { href = bisFrame.contentWindow.location.href; } catch (err) { foreign = true; }
      if (foreign || /[?&]customer_posted=true/.test(href)) {
        try { sessionStorage.removeItem('tdhq-bis-sent'); } catch (err) {}
        bisEnd('done');
      } else if (/\/challenge/.test(href)) {
        bisBusy = false;
        bisForm.target = '_self';
        HTMLFormElement.prototype.submit.call(bisForm);
      } else {
        bisEnd('error');
      }
    });
    /* Back from a visible CAPTCHA: Shopify returns to this page with
       customer_posted=true, so the dialog opens on its thank-you. */
    var bisBack = false;
    try { bisBack = sessionStorage.getItem('tdhq-bis-sent') === '1'; } catch (err) {}
    if (bisBack && /[?&]customer_posted=true/.test(window.location.search)) {
      try { sessionStorage.removeItem('tdhq-bis-sent'); } catch (err) {}
      bisState('done');
      bisDlg.showModal();
    }
  }
  /* ...and "See similar in stock" goes to the first rail of other products
     on the page. The rails are later sections, not parsed yet when this
     runs, so they are looked for once the page is complete; a page with no
     rail holding a product does not offer the link. */
  var similar = document.querySelector('[data-pdp-similar]');
  function railOnPage() {
    var rails = document.querySelectorAll('.dtc-section-related, .tdhq-section-pdp-recs, .dtc-section-recently');
    for (var r = 0; r < rails.length; r++) { if (rails[r].querySelector('.tdhq-pcard')) { return rails[r]; } }
    return null;
  }
  if (similar) {
    similar.addEventListener('click', function (e) {
      var rail = railOnPage();
      if (!rail) { return; }
      e.preventDefault();
      rail.scrollIntoView({ behavior: (window.tdhqMotion ? window.tdhqMotion.behavior() : 'smooth'), block: 'start' });
    });
    var checkRail = function () { if (!railOnPage()) { similar.hidden = true; } };
    if (window.location.hash === '#similar') {
      window.addEventListener('load', function () { var r = railOnPage(); if (r) { r.scrollIntoView({ block: 'start' }); } });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', checkRail); } else { checkRail(); }
  }

  /* Shopify answers a contact post with a redirect back to this page, so the
     confirmation - or the reason it was refused - would otherwise render
     inside a dialog nobody has opened, and the shopper was left at the top
     of the page with no sign the question went (REQ-PDP-18). The notes are
     rendered inside the form, where Shopify knows the answer. */
  if (dlg.querySelector('.dtc-askq__sent, .dtc-askq__error')) { open(); }
  /* Arriving from quick view's size guide ("Ask about sizing"): this page
     with the popup open and the sizing question started. */
  else if (window.location.hash === '#ask-sizing') { begin('Sizing question: I usually wear size '); }
  else if (window.location.hash === '#pdp-ask-question') { open(); }
  /* ...and quick view's two ways on from a sold-out choice */
  else if (window.location.hash === '#ask-back' && backAsk) { backAsk.click(); }
})();
